/** Libellé agrément taxi — base opérationnelle La Grand-Croix (Loire 42) */
export const TAXI_AGREMENT_BADGE = 'Taxi agréé · Loire (42) · La Grand-Croix';

export const TAXI_BASE_CITY = 'La Grand-Croix';

export const TAXI_BASE_POSTAL = '42320';

export const TAXI_PHONE_DISPLAY = '06 62 10 71 42';
export const TAXI_PHONE_TEL = '+33662107142';
export const TAXI_EMAIL = 'taxiabel42@gmail.com';
export const TAXI_SITE = 'taxiabel.fr';
export const GA_MEASUREMENT_ID = 'G-SMBLTYTTCJ';
